import PropTypes from "prop-types";
import { useState } from "react";

// material-ui
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

// assets
// import { EditOutlined, ProfileOutlined, LogoutOutlined, UserOutlined, WalletOutlined } from '@ant-design/icons';
import { PersonOutline } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { activeItem } from '../../../../../stateManagement/reducers/menuReducer';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

const ProfileTab = ({ handleLogout }) => {
  const theme = useTheme();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedIndex, setSelectedIndex] = useState(-1);
  const handleListItemClick = (event, index, uri) => {
    setSelectedIndex(index);
    navigate(uri, { replace: true });
    // dispatch(activeItem({ openItem: [-1] }));
  };

  return (
    <List
      component="nav"
      sx={{
        p: 0,
        pl: { xs: "0", md: "2rem" },
        "& .MuiListItemIcon-root": {
          minWidth: 32,
          color: theme.palette.grey[500],
        },
      }}
    >
      <ListItemButton
        selected={selectedIndex === 0}
        onClick={(event) => handleListItemClick(event, 0, "/member/profile")}
      >
        <ListItemIcon>
          <PersonOutline
            sx={{
              height: "1.5rem !important",
              width: "1.5rem !important",
              color: "rgba(0,0,0, .5) !important",
            }}
          />
        </ListItemIcon>
        <ListItemText primary="Your Profile" />
      </ListItemButton>
    </List>
  );
};

ProfileTab.propTypes = {
  handleLogout: PropTypes.func,
};

export default ProfileTab;
